// Version : 1.0.0
// Author : AGALYA

const arrearCollectionActionTypes = {
	/** ***************** UPDATE COMMON LOAN PAID DETAILS START *********************** */
	UPDATE_COMMON_LOAN_PAID_DETAILS_START: 'UPDATE_COMMON_LOAN_PAID_DETAILS_START',
	UPDATE_COMMON_LOAN_PAID_DETAILS_SUCCESS: 'UPDATE_COMMON_LOAN_PAID_DETAILS_SUCCESS',
	UPDATE_COMMON_LOAN_PAID_DETAILS_FAILURE: 'UPDATE_COMMON_LOAN_PAID_DETAILS_FAILURE',
	UPDATE_COMMON_LOAN_PAID_DETAILS_RESPONSE_RESET:
		'UPDATE_COMMON_LOAN_PAID_DETAILS_RESPONSE_RESET',
	UPDATE_COMMON_LOAN_PAID_DETAILS_RESPONSE_CHANGED:
		'UPDATE_COMMON_LOAN_PAID_DETAILS_RESPONSE_CHANGED',
	/** ***************** UPDATE COMMON LOAN PAID DETAILS END *********************** */
	/** *********************  START MEMBER LOAN LIST DETAILS  ******************** */
	GET_ARREAR_LOAN_LIST_START: 'GET_ARREAR_MEMBER_LOAN_LIST_START',
	GET_ARREAR_LOAN_LIST_SUCCESS: 'GET_ARREAR_MEMBER_LOAN_LIST_SUCCESS',
	GET_ARREAR_LOAN_LIST_FAILURE: 'GET_ARREAR_MEMBER_LOAN_LIST_FAILURE',
	GET_ARREAR_LOAN_LIST_RESPONSE_RESET: 'GET_ARREAR_MEMBER_LOAN_LIST_RESPONSE_RESET',
	GET_ARREAR_LOAN_LIST_RESPONSE_CHANGED: 'GET_ARREAR_MEMBER_LOAN_LIST_RESPONSE_CHANGED',
	/** *********************  START MEMBER LOAN LIST DETAILS  ******************** *

	/** ***************** UPDATE ARREAR COLLECTION APPROVE START *********************** */
	UPDATE_ARREAR_COLLECTION_APPROVE_START: 'UPDATE_ARREAR_COLLECTION_APPROVE_START',
	UPDATE_ARREAR_COLLECTION_APPROVE_SUCCESS: 'UPDATE_ARREAR_COLLECTION_APPROVE_SUCCESS',
	UPDATE_ARREAR_COLLECTION_APPROVE_FAILURE: 'UPDATE_ARREAR_COLLECTION_APPROVE_FAILURE',
	UPDATE_ARREAR_COLLECTION_APPROVE_RESPONSE_RESET:
		'UPDATE_ARREAR_COLLECTION_APPROVE_RESPONSE_RESET',
	UPDATE_ARREAR_COLLECTION_APPROVE_RESPONSE_CHANGED:
		'UPDATE_ARREAR_COLLECTION_APPROVE_RESPONSE_CHANGED',
	/** ***************** UPDATE ARREAR COLLECTION APPROVE START *********************** */
};
export default arrearCollectionActionTypes;
